import Template1 from "../../../../../../assets/svg/tableTempletes/template1.svg";
import Template2 from "../../../../../../assets/svg/tableTempletes/template2.svg";
import Template3 from "../../../../../../assets/svg/tableTempletes/template3.svg";
import Template4 from "../../../../../../assets/svg/tableTempletes/template4.svg";
import Template5 from "../../../../../../assets/svg/tableTempletes/template5.svg";
import Template6 from "../../../../../../assets/svg/tableTempletes/template6.svg";
import Template7 from "../../../../../../assets/svg/tableTempletes/template7.svg";
import Template8 from "../../../../../../assets/svg/tableTempletes/template8.svg";
import Template9 from "../../../../../../assets/svg/tableTempletes/template9.svg";
import Template10 from "../../../../../../assets/svg/tableTempletes/template10.svg";
import Template11 from "../../../../../../assets/svg/tableTempletes/template11.svg";
import Template12 from "../../../../../../assets/svg/tableTempletes/template12.svg";
import Template13 from "../../../../../../assets/svg/tableTempletes/template13.svg";
import Template14 from "../../../../../../assets/svg/tableTempletes/template14.svg";
import Template15 from "../../../../../../assets/svg/tableTempletes/template15.svg";
import Template16 from "../../../../../../assets/svg/tableTempletes/template16.svg";
import Template17 from "../../../../../../assets/svg/tableTempletes/template17.svg";
import Template18 from "../../../../../../assets/svg/tableTempletes/template18.svg";
import Template19 from "../../../../../../assets/svg/tableTempletes/template19.svg";
import Template20 from "../../../../../../assets/svg/tableTempletes/template20.svg";
import Template21 from "../../../../../../assets/svg/tableTempletes/template21.svg";
import Template22 from "../../../../../../assets/svg/tableTempletes/template22.svg";
import Template23 from "../../../../../../assets/svg/tableTempletes/template23.svg";
import Template24 from "../../../../../../assets/svg/tableTempletes/template24.svg";
import Template25 from "../../../../../../assets/svg/tableTempletes/template25.svg";
import Template26 from "../../../../../../assets/svg/tableTempletes/template26.svg";
import Template27 from "../../../../../../assets/svg/tableTempletes/template27.svg";
import Template28 from "../../../../../../assets/svg/tableTempletes/template28.svg";
import Template29 from "../../../../../../assets/svg/tableTempletes/template29.svg";
import Template30 from "../../../../../../assets/svg/tableTempletes/template30.svg";
import Template31 from "../../../../../../assets/svg/tableTempletes/template31.svg";


export const templateSvgs = [
    {
        _id: "template1",
        icon: Template1,
        label: "Template 1",
        style: {
            header: {
                border: "none",
                background: "white",
                color: "#121212",
            },
            body: {
                border: "none",
                color: "#121212",
            },
            bodyBackground: {
                background: "white",
            }
        }
    },
    {
        _id: "template2",
        icon: Template2,
        label: "Template 2",
        style: {
            outerBorder: {
                borderBottom: "1px solid #FFC700"
            },
            header: {
                borderTop: "1px solid #FFC700",
                borderBottom: "1px solid #FFC700",
                background: "white",
                color: "#FFC700",
            },
            body: {
                border: "none",
                color: "#FFC700",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#FFF7DB"
                }
            }
        }
    },
    {
        _id: "template3",
        icon: Template3,
        label: "Template 3",
        style: {
            outerBorder: {
                borderBottom: "1px solid #70AD47"
            },
            header: {
                borderTop: "1px solid #70AD47",
                borderBottom: "1px solid #70AD47",
                background: "white",
                color: "#70AD47",
            },
            body: {
                border: "none",
                color: "#70AD47",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#EAFFDC"
                }
            }
        }
    },
    {
        _id: "template4",
        icon: Template4,
        label: "Template 4",
        style: {
            outerBorder: {
                borderBottom: "1px solid #E27841"
            },
            header: {
                borderTop: "1px solid #E27841",
                borderBottom: "1px solid #E27841",
                background: "white",
                color: "#E27841",
            },
            body: {
                border: "none",
                color: "#E27841",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#FFE8DC"
                }
            }

        }
    },
    {
        _id: "template5",
        icon: Template5,
        label: "Template 5",
        style: {
            outerBorder: {
                borderCollapse: "collapse",
                borderSpacing: "0px",
                border: "1px solid #969BA5"
            },
            header: {
                borderCollapse: "collapse",
                borderSpacing: "0px",
                border: "1px solid #969BA5",
                background: "white",
                color: "#121212",
            },
            body: {
                borderCollapse: "collapse",
                borderSpacing: "0px",
                border: "1px solid #969BA5",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#D3D3D3"
                }
            }
        }
    },
    {
        _id: "template6",
        icon: Template6,
        label: "Template 6",
        style: {
            outerBorder: {
                borderCollapse: "collapse",
                borderSpacing: "0px",
                border: "1px solid #FFC700"
            },
            header: {
                border: "1px solid #FFC700",
                background: "white",
                color: "#121212",
            },
            body: {
                border: "1px solid #FFC700",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#FFF7DB"
                }
            }
        }
    },
    {
        _id: "template7",
        icon: Template7,
        label: "Template 7",
        style: {
            outerBorder: {
                border: "1px solid #70AD47"
            },
            header: {
                border: "1px solid #70AD47",
                background: "white",
                color: "#121212",
            },
            body: {
                border: "1px solid #70AD47",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#EAFFDC"
                }
            }
        }
    },
    {
        _id: "template8",
        icon: Template8,
        label: "Template 8",
        style: {
            outerBorder: {
                border: "1px solid #E27841"
            },
            header: {
                border: "1px solid #E27841",
                background: "white",
                color: "#121212",
            },
            body: {
                border: "1px solid #E27841",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#FFE8DC"
                }
            }
        }
    },
    {
        _id: "template9",
        icon: Template9,
        label: "Template 9",
        style: {
            outerBorder: {
                border: "none"
            },
            header: {
                border: "1px solid #FFFFFF",
                background: "#E27841",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #FFFFFF",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFE8DC"
                },
                odd: {
                    background: "#FFC9AD"
                }
            }
        }
    },
    {
        _id: "template10",
        icon: Template10,
        label: "Template 10",
        style: {
            outerBorder: {
                border: "none"
            },
            header: {
                border: "1px solid #FFFFFF",
                background: "#969BA5",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #FFFFFF",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#EFEFEF"
                },
                odd: {
                    background: "#D9D9D9"
                }
            }
        }
    },
    {
        _id: "template11",
        icon: Template11,
        label: "Template 11",
        style: {
            outerBorder: {
                border: "none"
            },
            header: {
                border: "1px solid #FFFFFF",
                background: "#FFC700",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #FFFFFF",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFF7DC"
                },
                odd: {
                    background: "#FFEBA5"
                }
            }
        }
    },
    {
        _id: "template12",
        icon: Template12,
        label: "Template 12",
        style: {
            outerBorder: {
                border: "none"
            },
            header: {
                border: "1px solid #FFFFFF",
                background: "#70AD47",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #FFFFFF",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#E8FADD"
                },
                odd: {
                    background: "#C6EEAC"
                }
            }
        }
    },
    {
        _id: "template13",
        icon: Template13,
        label: "Template 13",
        style: {
            outerBorder: {
                border: "none"
            },
            header: {
                border: "1px solid #FFFFFF",
                background: " #0466C8",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #FFFFFF",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#E8F3FF"
                },
                odd: {
                    background: "#CBE4FF"
                }
            }
        }
    },
    {
        _id: "template14",
        icon: Template14,
        label: "Template 14",
        style: {
            outerBorder: {
                border: "1px solid #0466C8"
            },
            header: {
                border: "1px solid #0466C8",
                background: "white",
                color: "#121212",
            },
            body: {
                border: "1px solid #0466C8",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#E8F3FF"
                }
            }
        }
    },
    {
        _id: "template15",
        icon: Template15,
        label: "Template 15",
        style: {
            outerBorder: {
                border: "none"
            },
            header: {
                border: "1px solid #FFFFFF",
                background: "#121212",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #FFFFFF",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#EEEEEE"
                },
                odd: {
                    background: "#D3D3D3"
                }
            }
        }
    },
    {
        _id: "template16",
        icon: Template16,
        label: "Template 16",
        style: {
            outerBorder: {
                border: "1px solid #969BA5"
            },
            header: {
                border: "1px solid #969BA5",
                background: "white",
                color: "#121212",
            },
            body: {
                border: "1px solid #969BA5",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#D3D3D3"
                }
            }
        }
    },
    {
        _id: "template17",
        icon: Template17,
        label: "Template 17",
        style: {
            outerBorder: {
                border: "1px solid #969BA5"
            },
            header: {
                border: "1px solid #969BA5",
                background: "#969BA5",
                color: "#FFFFFF",
            },
            body: {
                borderTop: "1px solid #969BA5",
                color: "#121212",
            },
            bodyBackground: {
                background: "white",
            }
        }
    },
    {
        _id: "template18",
        icon: Template18,
        label: "Template 18",
        style: {
            outerBorder: {
                border: "1px solid #969BA5"
            },
            header: {
                border: "1px solid #969BA5",
                background: "#969BA5",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #969BA5",
                color: "#121212",
            },
            bodyBackground: {
                background: "white",
            }
        }
    },
    {
        _id: "template19",
        icon: Template19,
        label: "Template 19",
        style: {
            outerBorder: {
                border: "1px solid #FFC700"
            },
            header: {
                border: "1px solid #FFC700",
                background: "#FFC700",
                color: "#FFFFFF",
            },
            body: {
                borderTop: "1px solid #FFC700",
                color: "#121212",
            },
            bodyBackground: {
                background: "white"
            }
        }
    },
    {
        _id: "template20",
        icon: Template20,
        label: "Template 20",
        style: {
            outerBorder: {
                border: "1px solid #FFC700"
            },
            header: {
                border: "1px solid #FFC700",
                background: "#FFC700",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #FFC700",
                color: "#121212",
            },
            bodyBackground: {
                background: "white"
            }
        }
    },
    {
        _id: "template21",
        icon: Template21,
        label: "Template 21",
        style: {
            outerBorder: {
                border: "1px solid #70AD47"
            },
            header: {
                border: "1px solid #70AD47",
                background: "#70AD47",
                color: "#FFFFFF",
            },
            body: {
                borderTop: "1px solid #70AD47",
                color: "#121212",
            },
            bodyBackground: {
                background: "white"
            }
        }
    },
    {
        _id: "template22",
        icon: Template22,
        label: "Template 22",
        style: {
            outerBorder: {
                border: "1px solid #70AD47"
            },
            header: {
                border: "1px solid #70AD47",
                background: "#70AD47",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #70AD47",
                color: "#121212",
            },
            bodyBackground: {
                background: "white"
            }
        }
    },
    {
        _id: "template23",
        icon: Template23,
        label: "Template 23",
        style: {
            outerBorder: {
                border: "1px solid #E27841"
            },
            header: {
                border: "1px solid #E27841",
                background: "#E27841",
                color: "#FFFFFF",
            },
            body: {
                borderTop: "1px solid #E27841",
                color: "#121212",
            },
            bodyBackground: {
                background: "white"
            }
        }
    },
    {
        _id: "template24",
        icon: Template24,
        label: "Template 24",
        style: {
            outerBorder: {
                border: "1px solid #E27841"
            },
            header: {
                border: "1px solid #E27841",
                background: "#E27841",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #E27841",
                color: "#121212",
            },
            bodyBackground: {
                background: "white"
            }
        }
    },
    {
        _id: "template25",
        icon: Template25,
        label: "Template 25",
        style: {
            outerBorder: {
                border: "1px solid #0466C8"
            },
            header: {
                border: "1px solid #0466C8",
                background: "#0466C8",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #0466C8",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#E8F3FF"
                }
            }
        }
    },
    {
        _id: "template26",
        icon: Template26,
        label: "Template 26",
        style: {
            outerBorder: {
                border: "1px solid #0466C8"
            },
            header: {
                border: "1px solid #0466C8",
                background: "#0466C8",
                color: "#FFFFFF",
            },
            body: {
                borderTop: "1px solid #0466C8",
                color: "#121212",
            },
            bodyBackground: {
                background: "white"
            }
        }
    },
    {
        _id: "template27",
        icon: Template27,
        label: "Template 27",
        style: {
            outerBorder: {
                border: "1px solid #121212"
            },
            header: {
                border: "1px solid #121212",
                background: "#121212",
                color: "#FFFFFF",
            },
            body: {
                border: "1px solid #121212",
                color: "#121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#ECECEC"
                }
            }
        }
    },
    {
        _id: "template28",
        icon: Template28,
        label: "Template 28",
        style: {
            outerBorder: {
                border: "1px solid #121212"
            },
            header: {
                border: "1px solid #121212",
                background: "#121212",
                color: "#FFFFFF",
            },
            body: {
                borderTop: "1px solid #121212",
                color: "#121212",
            },
            bodyBackground: {
                background: "white"
            }
        }
    },
    {
        _id: "template29 ",
        icon: Template29,
        label: "Template 29 ",
        style: {
            outerBorder: {
                borderBottom: "1px solid #000000"
            },
            header: {
                borderTop: "1px solid #000000",
                borderBottom: "1px solid #000000",
                background: "white",
                color: "#000000",
            },
            body: {
                border: "none",
                color: "#000000",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#D9D9D9"
                }
            }
        }
    },
    {
        _id: "template30",
        icon: Template30,
        label: "Template 30",
        style: {
            outerBorder: {
                borderBottom: "1px solid #969BA5"
            },
            header: {
                borderTop: "1px solid #969BA5",
                borderBottom: "1px solid #969BA5",
                background: "white",
                color: " #121212",
            },
            body: {
                border: "none",
                color: " #121212",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#F2F2F2"
                }
            }
        }
    },
    {
        _id: "template31",
        icon: Template31,
        label: "Template 31",
        style: {
            outerBorder: {
                borderBottom: "1px solid #0466C8"
            },
            header: {
                borderTop: "1px solid #0466C8",
                borderBottom: "1px solid #0466C8",
                background: "white",
                color: "#0466C8",
            },
            body: {
                border: "none",
                color: "#0466C8",
            },
            bodyBackground: {
                background: "inherit",
                even: {
                    background: "#FFFFFF"
                },
                odd: {
                    background: "#E8F3FF"
                }
            }
        }
    },
]

